import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-col-12 q-col-md-6 q-col-lg-3 q-d-block q-d-lg-none q-pb-2 q-pb-sm-0 q-p-0 q-p-sm-1" }

import {inject} from "vue";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {SmartSearchTranslationsInterface} from "@/core/types";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'MobileFiltersButton',
  setup(__props) {

const filtersStore = useFiltersStore();
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "q-btn q-btn q-btn-danger q-rounded-3 q-shadow-sm",
      id: "showFiltersOnMobile",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(filtersStore).showFiltersOnMobile && _unref(filtersStore).showFiltersOnMobile(...args)))
    }, _toDisplayString(_unref(SmartSearchTranslations).filters.show), 1)
  ]))
}
}

})